const vouchersAltTextI18nDe = {
  'altTextVoucherImage1': 'Repair Rebels Geschenkgutschein nachhaltiger Modereparatur Service',
  'altTextVoucherImage2': 'Nachhaltiger Geschenkgutschein für Mode-, Kleidungs- und Schuhreparaturen',
};

export default vouchersAltTextI18nDe;
